import { googleClient } from '@service-initiation/shared-clients-google';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import { queryClient } from '@service-initiation/shared-utils-query-client';

export const addressToLatLong = async (address: string) => {
  return await queryClient.fetchQuery({
    queryFn: async () => {
      try {
        const response = await (
          await googleClient
        ).geoCoder.geocode({ address }, (results) => results);
        const [location] = response.results.map(({ geometry }) => {
          return geometry.location;
        });

        return {
          lat: location.lat(),
          lng: location.lng(),
        };
      } catch (e) {
        const err = e as Error;
        err.message = 'Failed to convert to lat lng';
        logger.error(err);
        throw err;
      }
    },
    queryKey: ['addressToLatLong', address],
    retry: 2,
    staleTime: Infinity,
  });
};
